<div class="pagination-bar d-flex flex-wrap justify-content-center align-items-center mt-2">
  @if (totalEntries > pagination.pageSize) {
    <pagination [totalItems]="totalEntries" [itemsPerPage]="pagination.pageSize" [(ngModel)]="pagination.currentPage" [maxSize]="maxSize" (pageChanged)="onPageChange($event)" [directionLinks]="true" [boundaryLinks]="true"></pagination>
    @if (showJump) {
      <form class="pagination-jump d-flex align-items-center" (submit)="$event.preventDefault(); onJump(jumpInput)" data-testid="pagination-jump">
        <label class="mb-0 me-2 text-nowrap" [for]="jumpInputId">{{ 'PAGINATION.PAGE' | translate }}</label>
        <input class="form-control text-center pagination-jump__input" #jumpInput type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" [id]="jumpInputId" [value]="jumpPage" (blur)="onJump(jumpInput)" [attr.aria-label]="'PAGINATION.GO_TO_PAGE' | translate"/>
        <span class="ms-2 text-nowrap">{{ 'PAGINATION.OF' | translate : { total: totalPages } }}</span>
      </form>
    }
  }
</div>
